export function loadScript(key: string) {
  const g = document.createElement("script");
  const s = document.getElementsByTagName("script")[0];
  g.src = `https://gleam.io/${key}/trk.js`;
  if (s.parentNode) {
    s.parentNode.insertBefore(g, s);
  }
}
